import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import { NavLink} from "react-router-dom";
import "@aws-amplify/ui-react/styles.css";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Flex, Divider, Text, Heading, View, Button, } from '@aws-amplify/ui-react';
import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { multiRowSelection } from '../agGridRowSelection';
//import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
//import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { themeQuartz } from 'ag-grid-community';
import Loadingmini from '../components/loadingmini';
import { AgCharts } from 'ag-charts-react';
import { withFleets } from '../withFleets';
//import User from './user';


export default function Accidentinspector({userJwt, refreshJwt, vehicle}) {
  const [is_loading, updateIsLoading] = React.useState(false);
  const [has_searched, updateHasSearched] = React.useState(false);
  const roundBack = (date,hours) => {
    date.setHours(date.getHours() - hours);
    date.setMinutes(0, 0, 0);
    return date;
  }
  const [searchdate, setSearchDate] = useState(roundBack(new Date(),12));
  const [res, updateRes] = useState({status:"Contact support if this message stays for more than 30 seconds",driver_job_data:[],vehicle_telemetry_data:[],res_schedule_data:[],series_data_hbha:[],series_data_speed:[]})
  const [myerror, updateMyerror] = React.useState(false);
  
  const [seriesData, updateSeriesData] = useState([{'hbha_timestamp':0,'hbha_datetime':'-','hbha_value':0}])
  const [seriesDataSpeed, updateSeriesDataSpeed] = useState([{'speed_timestamp':0,'speed_datetime':'--','speed_value':0}])
  const [seriesMinDatetime, updateSeriesMinDatetime] = useState(roundBack(new Date(),11));  // Keeping this in case we want to use it for display
  const [seriesMaxDatetime, updateSeriesMaxDatetime] = useState(roundBack(new Date(),13));  // Keeping this in case we want to use it for display
  const [seriesMinTimestamp, updateSeriesMinTimestamp] = useState(0);
  const [seriesMaxTimestamp, updateSeriesMaxTimestamp] = useState(5702755185);

  const [chartOptions, setChartOptions] = useState({
    data: seriesData,
    title: {text: 'Hard Brake and Hard Acceleration Events over Time'},
    subtitle: {text: '+/- 2 hours from selected time, miles per hour per second'},
    series: [
      { type: 'scatter', xKey: 'hbha_timestamp', yKey: 'hbha_value' }
    ],
    axes: [
        {
          type: "number",
          position: "bottom",
          min: seriesMinTimestamp,
          max: seriesMaxTimestamp,
          label: {
              formatter: (params) => {
                const dataItem = chartOptions.data.find((item) => item.hbha_timestamp === params.value);
                return dataItem ? dataItem.hbha_datetime : params.value;
              }
          }
        },
        {
            type: "number",
            position: "left",
            label: {
                format: "#{.1f} mph/s"
            }
        }
    ]
  })
  const [chartOptionsSpeed, setChartOptionsSpeed] = useState({
    data: seriesDataSpeed,
    title: {text: 'Speeding Events over Time'},
    subtitle: {text: '+/- 2 hours from selected time, miles per hour'},
    series: [
      { type: 'line', xKey: 'speed_timestamp', yKey: 'speed_value' }
    ],
    axes: [
        {
          type: "number",
          position: "bottom",
          min: seriesMinTimestamp,
          max: seriesMaxTimestamp,
          label: {
              formatter: (params) => {
                const dataItemSpeed = chartOptionsSpeed.data.find((item) => item.speed_timestamp === params.value);
                return dataItemSpeed ? dataItemSpeed.speed_datetime : params.value;
              }
          }
        },
        {
            type: "number",
            position: "left",
            label: {
                format: "#{.1f} mph"
            }
        }
    ]
  })
  const columns = [
      {
        headerName: 'Platform',
        field: 'trip_empl',
        filter: true
      },
      {
        headerName: 'Start Datetime',
        field: 'start_datetime',
        filter: true
      },
      {
        headerName: 'End Datetime',
        field: 'end_datetime',
        filter: true
      }
  ];
  const columns_schedule_data = [
      {
        headerName: 'Driver ID',
        width: 100,
        field: 'driver_id',
        filter: true,
        pinned: 'left',
        cellRenderer: params => {
            let val = params.value
            var link = withFleets('/user/' + String(val), vehicle && vehicle.fleet_code) 
            return( <NavLink to={link} index = {val}>{val}</NavLink>)
        }
      },
      {
        headerName: 'Driver Name',
        field: 'driver_name_full',
        filter: true
      },
      {
        headerName: 'Start Datetime',
        field: 'start_datetime',
        filter: true
      },
      {
        headerName: 'End Datetime',
        field: 'end_datetime',
        filter: true
      }
  ];
  const columns_vehicle_telemetry = [
      {
        headerName: 'Data Datetime',
          field: 'data_datetime',
          filter: true
      },
      {
        headerName: 'Data Timestamp',
          field: 'data_timestamp',
          filter: true
      },
      {
        headerName: 'Car OEM',
          field: 'car_oem',
          filter: true
      },
      {
        headerName: 'Odometer (miles)',
          field: 'odometer',
          filter: true
      },
      {
        headerName: 'Odometer Datetime',
          field: 'odometer_datetime',
          filter: true
      },
      {
        headerName: 'Odometer Timestamp',
          field: 'odometer_timestamp',
          filter: true
      },
      {
        headerName: 'Latitude',
          field: 'latitude',
          filter: true
      },
      {
        headerName: 'Longitude',
          field: 'longitude',
          filter: true
      },
      {
        headerName: 'GPS Datetime',
          field: 'position_datetime',
          filter: true
      },
      {
        headerName: 'GPS Timestamp',
          field: 'position_timestamp',
          filter: true
      },
      {
        headerName: 'Speed (mph)',
          field: 'speed',
          filter: true
      },
      {
        headerName: 'Speed Timestamp',
          field: 'speed_timestamp',
          filter: true
      },
      {
        headerName: 'Speed Datetime',
          field: 'speed_datetime',
          filter: true
      },
      {
        headerName: 'Accel/Brake (mph per sec)',
          field: 'hbha',
          filter: true
      },
      {
        headerName: 'Accel/Brake Datetime',
          field: 'hbha_datetime',
          filter: true
      },
      {
        headerName: 'Accel/Brake Timestamp',
          field: 'hbha_timestamp',
          filter: true
      }
  ];
  

  function formatSeriesData(thisSeriesData, seriesType)
  {
    if(!thisSeriesData){
      return;
    }
    var seriesDataFormatted = []
    switch(seriesType)
    {
      case 'hbha':
            thisSeriesData.map(function(object, index){
              var thisValue = object['hbha_value']
              var thisDatetimeStart = object['hbha_datetime']
              var thisDatetime = new Date(thisDatetimeStart)
              var thisEntry = {'hbha_datetime':thisDatetime, 'hbha_value':thisValue}
              seriesDataFormatted.push(thisEntry)
            })
        break;
      case 'speed':
        thisSeriesData.map(function(object, index){
          var thisValue = object['speed_value']
          var thisDatetimeStart = object['speed_datetime']
          var thisDatetime = new Date(thisDatetimeStart)
          var thisEntry = {'speed_datetime':thisDatetime, 'speed_value':thisValue}
          seriesDataFormatted.push(thisEntry)
        })
      break;
    }
    return seriesDataFormatted
  }


  async function fetchPageData() {
    updateIsLoading(true)
    updateMyerror(false)
    if(vehicle)
    {
        if(vehicle['resp'])
        {
            if(vehicle['resp'][0])
            {
                if(vehicle['resp'][0]['car_id'])
                {
                    //console.log('accidentinspector vehicle '+ vehicle['resp'][0]['car_id'])
                    //var searchdateString1 = searchdate.toLocaleDateString(undefined, options)
                    //var searchdateString2 = searchdate.toLocaleTimeString()
                    //var searchdateString = searchdateString1 + " " + searchdateString2

                    // Get date components
                    var year = searchdate.getFullYear();
                    var month = String(searchdate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
                    var day = String(searchdate.getDate()).padStart(2, '0');

                    // Get time components
                    var hours = String(searchdate.getHours()).padStart(2, '0');
                    var minutes = String(searchdate.getMinutes()).padStart(2, '0');

                    // Format the string
                    var searchdateString = `${year}-${month}-${day} ${hours}:${minutes}`;

                    let session = await Auth.currentSession()      
                    let accessToken = session.getAccessToken()
                    const myInit = {queryStringParameters:{ 
                        "back_end": process.env.REACT_APP_BACKEND,
                        "jwt": userJwt,
                        "api_endpoint":"api3:vehicles:accident_inspector",
                        "request_type":"GET",
                        "vehicle_id":vehicle['resp'][0]['car_id'],
                        "datetime":searchdateString
                    }};
                    const options = {
                      year: 'numeric',
                      month: 'numeric',
                      day: 'numeric',
                    };
                    console.log('myInit: '+JSON.stringify(myInit))
                    //console.log('vehicle: '+vehicle['resp'][0]['car_id'])
                    //console.log('datetime: '+searchdate)
                    //console.log('str(datetime): '+searchdate.toString())
                    //console.log('searchdateString: '+searchdateString)

                    try {
                        const res = await API.get('adminWebTools','/ago',myInit)
                        console.log('accidentinspector response: '+JSON.stringify(res))
                        if (res?.detail && !Array.isArray(res.res_schedule_data)) {
                          const detailText = typeof res.detail === 'string'
                            ? res.detail
                            : JSON.stringify(res.detail);
                          updateMyerror("Error running Accident Detective search: " + detailText);
                          updateHasSearched(true);
                          updateIsLoading(false);
                          return;
                        }
                        updateRes(res)
                        updateSeriesMinTimestamp(res.series_min_timestamp ?? 0)
                        updateSeriesMaxTimestamp(res.series_max_timestamp ?? 5702755185)
                        
                        /* graph 1 hbha */
                        const hbhaData = Array.isArray(res.series_data_hbha) ? res.series_data_hbha : []
                        updateSeriesData(hbhaData)
                        var tchartOptions = chartOptions
                        tchartOptions.data = hbhaData
                        tchartOptions.axes[0].min = res.series_min_timestamp ?? 0
                        tchartOptions.axes[0].max = res.series_max_timestamp ?? 5702755185
                        setChartOptions(tchartOptions)
                        /* end graph 1 hbha */
                        /* graph 2 speed */
                        const speedData = Array.isArray(res.series_data_speed) ? res.series_data_speed : []
                        updateSeriesDataSpeed(speedData)
                        tchartOptions = chartOptionsSpeed
                        tchartOptions.data = speedData
                        tchartOptions.axes[0].min = res.series_min_timestamp ?? 0
                        tchartOptions.axes[0].max = res.series_max_timestamp ?? 5702755185
                        setChartOptionsSpeed(tchartOptions)
                        /* end graph 2 speed */
                        updateHasSearched(true)
                        updateMyerror(false)
                        if('detail' in res)
                        {
                            if(res['detail'].includes("token"))
                            {
                                refreshJwt()
                            }
                        }
                        updateIsLoading(false)
                    }
                    catch (e) {
                        console.log('accidentinspector error: '+JSON.stringify(e));
                        const errorMessage = e?.response?.data?.detail
                          ?? e?.message
                          ?? JSON.stringify(e);
                        updateMyerror("Error running Accident Detective search: " + errorMessage);
                        updateHasSearched(true)
                        updateIsLoading(false)
                    }
                }
            }
        }
    }
  }




  return (
      <Flex
        direction="column"
      >
        <View style={{padding:"1rem"}}>
            <Divider />
            {
                is_loading ? <Loadingmini /> : 
                <Flex 
                    direction='column'
                >
                    <Heading level={2}>Accident Detective</Heading>
                    <Text style={{width:'100%'}}>Enter a date to search for vehicle and driver data around that time, including telemetry, driver jobs and more.</Text>
                    <Flex direction="column" alignItems="flex-start">
                        <Text>Date to search (vehicle local time):</Text>
                        <DatePicker
                              name="searchdate"
                              selected={searchdate}
                              onChange={(date) => setSearchDate(date)}
                              showTimeSelect
                              dateFormat="MMMM d, yyyy h:mm aa"
                              timeIntervals={60}
                            />
                    </Flex>
                    <View>
                        <Button onClick={() => fetchPageData()}>
                            SUBMIT
                        </Button>
                    </View>
                    <Divider />
                    {
                      myerror ?
                      <View>
                        <Heading level={4}>Whoops!</Heading>
                        <Text>{myerror}</Text>
                      </View>
                      : undefined
                    }
                    <Text><i>Hint: Enter a date and click submit to search, no data initially loaded.</i></Text>
                    {
                        has_searched === false ? <Text>Search a date to investigate.</Text> :
                        <Flex direction="column">
                            <View style={{width:"100%"}}>
                              <Heading level={4}>Reservation Match</Heading>
                              <Text>Reservation for this vehicle at the selected time{/*searchdate === false ? undefined : searchdate.toLocaleDateString() + " (vehicle timezone)"*/}</Text>
                              {
                                  !Array.isArray(res.res_schedule_data) ?
                                  <Text>Error locating reservation on the schedule at this time.</Text>
                                  :
                                  res.res_schedule_data.length < 1 ?
                                  <Text>No reservation on the schedule at this time. Telemetry below may still be available for the selected time.</Text>
                                  :
                                  <View 
                                      theme={themeQuartz} // applying the grid theme
                                      style={{ height: 150 }} // the grid will fill the size of the parent container
                                  >
                                          <AgGridReact
                                              rowData={res.res_schedule_data}
                                              columnDefs={columns_schedule_data}
                                              rowSelection={multiRowSelection}
                                              paginationPageSize={150}
                                              paginationPageSizeSelector={[10, 25, 50]}
                                              enableCellTextSelection={true}
                                          />
                                  </View>
                              }
                            </View>
                            <View style={{width:"100%"}}>
                                <Heading level={4}>Jobs for Reservation Driver</Heading>
                                <Text>Jobs for the Driver of the Reservation Match within +/- 24 hours of the selected time{/*searchdate === false ? undefined : searchdate.toLocaleDateString() + " (vehicle timezone)"*/}.</Text>
                                {
                                    !Array.isArray(res.driver_job_data) ?
                                    <Text>No jobs found within range.</Text>
                                    :
                                    res.driver_job_data.length < 1 ?
                                    <Text>No jobs found within range.</Text>
                                    :
                                    <View 
                                        theme={themeQuartz} //className="ag-theme-quartz" // applying the grid theme
                                        style={{ height: 500 }} // the grid will fill the size of the parent container
                                    >
                                            <AgGridReact
                                                rowData={res.driver_job_data}
                                                columnDefs={columns}
                                                rowSelection={multiRowSelection}
                                                paginationPageSize={500}
                                                paginationPageSizeSelector={[10, 25, 50]}
                                                enableCellTextSelection={true}
                                            />
                                    </View>
                                }
                            </View>
                            <View style={{width:"100%"}}>
                                <AgCharts options={chartOptions} />
                            </View>
                            <View style={{width:"100%"}}>
                                <AgCharts options={chartOptionsSpeed} />
                            </View>
                            <View style={{width:"100%"}}>
                                <Heading level={4}>Vehicle Telemetry</Heading>
                                <Text>Telemetry readings for this vehicle +/- 2 hours of the selected time{/*searchdate === false ? undefined : searchdate.toLocaleDateString() + " (vehicle timezone)"*/}</Text>
                                {
                                    !Array.isArray(res.vehicle_telemetry_data) ?
                                    <Text>No telemetry.</Text>
                                    :
                                    res.vehicle_telemetry_data.length < 1 ?
                                    <Text>No telemetry.</Text>
                                    :
                                    <Flex direction="column" style={{width:"80vw"}}>
                                        <View 
                                            theme={themeQuartz} //className="ag-theme-quartz" // applying the grid theme
                                            style={{ height: 500 }} // the grid will fill the size of the parent container
                                        >
                                                <AgGridReact
                                                    rowData={res.vehicle_telemetry_data}
                                                    columnDefs={columns_vehicle_telemetry}
                                                    rowSelection={multiRowSelection}
                                                    pagination={true}
                                                    paginationAutoPageSize={true}
                                                    enableCellTextSelection={true}
                                                />
                                        </View>
                                    </Flex>
                                }
                            </View>
                            <View style={{width:"100%"}}>
                                <Heading level={4}>All Vehicle Reservations</Heading>
                                <Text>All reservations for this vehicle within +/- 24 hours of the selected time{/*searchdate === false ? undefined : searchdate.toLocaleDateString() + " (vehicle timezone)"*/}.</Text>
                                {
                                    !Array.isArray(res.all_res_schedule_data) ?
                                    <Text>No reservations found within range.</Text>
                                    :
                                    res.all_res_schedule_data.length < 1 ?
                                    <Text>No reservations found within +/- 24 hours of the selected time.</Text>
                                    :
                                    <View 
                                        theme={themeQuartz} //className="ag-theme-quartz" // applying the grid theme
                                        style={{ height: 500 }} // the grid will fill the size of the parent container
                                    >
                                            <AgGridReact
                                                rowData={res.all_res_schedule_data}
                                                columnDefs={columns_schedule_data}
                                                rowSelection={multiRowSelection}
                                                paginationPageSize={500}
                                                paginationPageSizeSelector={[10, 25, 50]}
                                                enableCellTextSelection={true}
                                            />
                                    </View>
                                }
                            </View>
                        </Flex>
                    }
                    <Divider />
                </Flex>
            }
        </View>
      </Flex>
  );
}
